import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';

export interface CreateDocTdDownloadDialogData {
  isDoc: boolean;
  blob: Blob;
  fileName: string;
  fileCount: number;
  fileSizeMb: number;
}

@Component({
  selector: 'app-create-doc-td-download-dialog',
  templateUrl: './create-doc-td-download-dialog.component.html',
  styleUrls: ['./create-doc-td-download-dialog.component.scss'],
})
export class CreateDocTdDownloadDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<CreateDocTdDownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocTdDownloadDialogData,
    private translateService: TranslocoService
  ) {}

  get documentTypeLabel(): string {
    return this.data.isDoc
      ? this.translateService.translate('createDoc.tdDownloadDialog.documentTypeDoc')
      : this.translateService.translate('createDoc.tdDownloadDialog.documentTypeTd');
  }

  get filePluralLabel(): string {
    return this.data.fileCount === 1
      ? this.translateService.translate('createDoc.tdDownloadDialog.fileSingular')
      : this.translateService.translate('createDoc.tdDownloadDialog.filePlural');
  }

  get formattedFileSize(): string {
    return `~${this.data.fileSizeMb.toFixed(1)} MB`;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSaveToDataspace() {
    this.dialogRef.close({ action: 'saveToDataset' });
  }

  onDownload() {
    const zipUrl = window.URL.createObjectURL(this.data.blob);
    const link = document.createElement('a');
    link.href = zipUrl;
    link.download = this.data.fileName;
    link.click();
    window.URL.revokeObjectURL(zipUrl);

    this.dialogRef.close({ action: 'download' });
  }
}
